<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">

    <template slot="buttons">
      <a :href="getGenerateHref(studentOpportunityAdditionalMaterialId, studentOpportunityId)" 
        target="_blank"
        class="ml-2 btn btn-primary pull-right" @click="submit()">Generate and Download</a>
      <b-btn variant="secondary" @click="previous()" class="ml-2 pull-right">Back</b-btn>
    </template>
                
  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {};
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    studentOpportunityAdditionalMaterialId: {
      type: Number,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  computed: {
    ...mapState({
      userId: state => state.additionalMaterials.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId
    })
  },

  methods: {
    ...mapActions("placements", ["postSubmit"]),
    getGenerateHref: function(
      studentOpportunityAdditionalMaterialId,
      studentOpportunityId
    ) {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/Downloads/GenerateAdditionalMaterial?studentOpportunityAdditionalMaterialId=" +
        studentOpportunityAdditionalMaterialId +
        "&studentOpportunityId=" +
        studentOpportunityId
      );
    },
    submit: function() {
      var materialId = this.studentOpportunityAdditionalMaterialId;
      this.postSubmit({
        materialId: materialId
      }).then(response => {
        if (response) {
          this.$emit("submitted");
        }
      });
    },
    previous: function() {
      this.$emit("previous");
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
